export enum WhatsappScope {
  chain = 'chain',
  places = 'places',
}

export namespace WhatsappScope {
  export const translateScope = (scope: WhatsappScope): string => {
    switch (scope) {
      case WhatsappScope.chain: return 'Rede inteira';
      case WhatsappScope.places: return 'Postos específicos';
      default: return '';
    }
  };

  export const scopeChoices = Object.values(WhatsappScope)
    .filter(x => typeof x === 'string')
    .map(scope => ({ id: scope, name: WhatsappScope.translateScope(scope as WhatsappScope) }));
}

export enum WhatsappActorType {
  owner = 'owner',
  manager = 'manager',
  staff = 'staff',
}

export namespace WhatsappActorType {
  export const translateActor = (actor: WhatsappActorType): string => {
    switch (actor) {
      case WhatsappActorType.owner: return 'Dono';
      case WhatsappActorType.manager: return 'Gerente';
      case WhatsappActorType.staff: return 'Equipe';
      default: return '';
    }
  };

  export const actorChoices = Object.values(WhatsappActorType)
    .filter(x => typeof x === 'string')
    .map(actor => ({ id: actor, name: WhatsappActorType.translateActor(actor as WhatsappActorType) }));
}

export enum SummaryFrequency {
  none = 'none',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}

export namespace SummaryFrequency {
  export const translateFrequency = (freq: SummaryFrequency): string => {
    switch (freq) {
      case SummaryFrequency.none: return 'Não receber';
      case SummaryFrequency.daily: return 'Todo dia';
      case SummaryFrequency.weekly: return 'Toda semana';
      case SummaryFrequency.monthly: return 'Todo mês';
      default: return '';
    }
  };

  export const frequencyChoices = Object.values(SummaryFrequency)
    .filter(x => typeof x === 'string')
    .map(freq => ({ id: freq, name: SummaryFrequency.translateFrequency(freq as SummaryFrequency) }));
}

export enum WhatsappIdentityStatus {
  active = 'active',
  revoked = 'revoked',
}

export namespace WhatsappIdentityStatus {
  export const translateStatus = (status: WhatsappIdentityStatus): string => {
    switch (status) {
      case WhatsappIdentityStatus.active: return 'Ativo';
      case WhatsappIdentityStatus.revoked: return 'Revogado';
      default: return '';
    }
  };

  export const statusChoices = Object.values(WhatsappIdentityStatus)
    .filter(x => typeof x === 'string')
    .map(s => ({ id: s, name: WhatsappIdentityStatus.translateStatus(s as WhatsappIdentityStatus) }));
}

/** Espelha formatPhoneBr do backend. Só para exibir — o backend normaliza. */
export const formatPhoneBr = (e164?: string): string => {
  if (!e164) return '';
  const m = e164.match(/^\+55(\d{2})(\d{4,5})(\d{4})$/);
  if (!m) return e164;
  return `+55 (${m[1]}) ${m[2]}-${m[3]}`;
};
